/**
 * OptionsSection.tsx
 * 人数, シート, 到着便, 出発便, プラン — すべてインライン編集
 */
import React from 'react';
import { SectionProps } from '../types';
import SectionHeader from '../shared/SectionHeader';
import InlineEditField from '../shared/InlineEditField';

export default function OptionsSection({
  data,
  onChange,
  disabled,
}: SectionProps) {
  return (
    <>
      <SectionHeader title="オプション・その他" />
      {/* 人数: 横2列 */}
      <div style={{ display: 'flex', gap: 8 }}>
        <div style={{ flex: 1 }}>
          <InlineEditField
            label="大人"
            field="pax"
            value={data.pax}
            onChange={onChange}
            disabled={disabled}
            type="number"
            suffix="名"
          />
        </div>
        <div style={{ flex: 1 }}>
          <InlineEditField
            label="子供"
            field="pax_children"
            value={data.pax_children}
            onChange={onChange}
            disabled={disabled}
            type="number"
            suffix="名"
          />
        </div>
      </div>
      {/* シート: 横3列 */}
      <div style={{ display: 'flex', gap: 8 }}>
        <div style={{ flex: 1 }}>
          <InlineEditField
            label="ブースター"
            field="booster_seat"
            value={data.booster_seat}
            onChange={onChange}
            disabled={disabled}
            type="number"
            suffix="台"
          />
        </div>
        <div style={{ flex: 1 }}>
          <InlineEditField
            label="チャイルド"
            field="child_seat"
            value={data.child_seat}
            onChange={onChange}
            disabled={disabled}
            type="number"
            suffix="台"
          />
        </div>
        <div style={{ flex: 1 }}>
          <InlineEditField
            label="ジュニア"
            field="junior_seat"
            value={data.junior_seat}
            onChange={onChange}
            disabled={disabled}
            type="number"
            suffix="台"
          />
        </div>
      </div>
      <InlineEditField
        label="オプション"
        field="option"
        value={data.option}
        onChange={onChange}
        disabled={disabled}
        type="textarea"
      />
      <InlineEditField
        label="プラン名"
        field="contact_plan"
        value={data.contact_plan}
        onChange={onChange}
        disabled={disabled}
        type="textarea"
      />
      {/* 到着便・出発便: 横2列 */}
      <div style={{ display: 'flex', gap: 8 }}>
        <div style={{ flex: 1 }}>
          <InlineEditField
            label="到着便"
            field="arrival_flight"
            value={data.arrival_flight}
            onChange={onChange}
            disabled={disabled}
          />
        </div>
        <div style={{ flex: 1 }}>
          <InlineEditField
            label="出発便"
            field="departure_flight"
            value={data.departure_flight}
            onChange={onChange}
            disabled={disabled}
          />
        </div>
      </div>
    </>
  );
}
